/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AtRiskReason {
  MEMBERSHIP_PAYMENT_FAILED = 'membership_payment_failed',
  MEMBERSHIP_CANCELLED = 'membership_cancelled',
  RECENTLY_EXPIRED = 'recently_expired',
  EXPIRING_SOON = 'expiring_soon',
  NO_PUNCHES_LEFT = 'no_punches_left',
}
